import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  Box,
  SwipeableDrawer,
  Input,
} from "@mui/material";
import React, { Fragment } from "react";
import "dayjs/locale/vi";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

import { WORK_STATUS } from "../../utils/constants";

const SearchAdvance = ({
  openSearchAdvance,
  handleOpenSearchAdvance,
  handleCloseSearchAdvance,
  filter,
  setFilter,
  checkV2,
  setCheckV2,
}) => {
  const handleChangeFromDate = (newValue) => {
    setFilter({
      ...filter,
      from_date: newValue.format("YYYY-MM-DD"),
    });
  };
  const handleChangeToDate = (newValue) => {
    setFilter({
      ...filter,
      to_date: newValue.format("YYYY-MM-DD"),
    });
  };
  const handleChangeStatus = (event) => {
    setFilter({ ...filter, status: event.target.value });
  };
  const handleChangeKeyword = (e) => {
    setFilter({
      ...filter,
      title: e.target.value.trim() === "" ? null : e.target.value,
    });
  };
  const handleChangeImportant = (event) => {
    setFilter({
      ...filter,
      is_important: event.target.checked,
    });
  };
  const handleChangeUnread = (event) => {
    setFilter({
      ...filter,
      is_unread: event.target.checked,
    });
  };
  const handleApply = () => {
    setFilter({ page: 0, size: 10, ...filter });
    handleCloseSearchAdvance();
  };
  const handleReset = () => {
    setFilter({
      ...filter,
      from_date: null,
      to_date: null,
      status: null,
      is_important: null,
      is_unread: null,
      title: null,
    });
    setCheckV2(!checkV2);
  };
  const list = (
    <>
      <Box
        sx={{
          width: "335px",
          pt: "50px",
          minHeight: "500px",
          "& ul": {
            position: "unset",
            marginBottom: "70px",
          },
        }}
        role="presentation"
      >
        <div className="px-5 mt-[50px] search-advance">
          <div className="min-h-[calc(100vh-90px)]">
            <p className="font-semibold text-sm leading-5 text-[#16192C]">
              Lọc nhanh
            </p>
            <p>
              <FormControlLabel
                className=""
                control={<Checkbox />}
                label="Công việc ưu tiên"
                onChange={handleChangeImportant}
                checked={!!filter?.is_important}
              />
            </p>
            <div>
              <FormControlLabel
                control={<Checkbox />}
                label="Công việc chưa đọc"
                onChange={handleChangeUnread}
                checked={!!filter?.is_unread}
              />
            </div>
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Ngày bắt đầu - kết thúc
            </p>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <div className="flex gap-3">
                <div className="mt-4">
                  <MobileDatePicker
                    inputFormat="DD/MM/YYYY"
                    value={filter?.from_date}
                    onChange={handleChangeFromDate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={false}
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                    initialFocusedDate={null}
                  />
                </div>
                <div className="mt-4">
                  <MobileDatePicker
                    inputFormat="DD/MM/YYYY"
                    // minDate={minDate}

                    value={filter?.to_date}
                    onChange={handleChangeToDate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={false}
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                  />
                </div>
              </div>
            </LocalizationProvider>
            <p className="font-semibold mt-4 text-sm leading-5 text-[#16192C] mb-2">
              Tìm kiếm
            </p>
            <Input
              style={{ borderColor: "#cdcdcd" }}
              className=" w-full border-[1px]   rounded-md px-2"
              placeholder="Tiêu đề"
              type="search"
              value={filter?.title !== null ? filter?.title : ""}
              onChange={handleChangeKeyword}
              disableUnderline
            />
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Trạng thái
            </p>
            <div>
              <Select
                displayEmpty
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filter?.status}
                onChange={handleChangeStatus}
                fullWidth
                placeholder="Chọn"
              >
                <MenuItem value={null}>Bỏ chọn</MenuItem>
                <MenuItem value={WORK_STATUS.COMPLETE}>Hoàn thành</MenuItem>
                <MenuItem value={WORK_STATUS.PENDING}>Chưa hoàn thành</MenuItem>
              </Select>
            </div>
          </div>
        </div>
      </Box>
      <div className="fixed flex bottom-0 w-[335px] bg-white h-20 p-4">
        <button
          onClick={handleReset}
          className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px] mr-[5px]"
        >
          <div className="font-semibold text-[14px] leading-[22px] px">
            Nhập lại
          </div>
        </button>
        <button
          onClick={handleApply}
          className="text-center w-1/2 border-[1px] block text-white rounded bg-primary py-[12px] ml-[5px]"
        >
          <div className="font-semibold text-[14px] leading-[22px] px">
            Áp dụng
          </div>
        </button>
      </div>
    </>
  );
  return (
    <Fragment>
      <SwipeableDrawer
        anchor={"right"}
        open={openSearchAdvance}
        onOpen={handleOpenSearchAdvance}
        onClose={handleCloseSearchAdvance}
        disableSwipeToOpen={false}
      >
        {list}
      </SwipeableDrawer>
    </Fragment>
  );
};

export default SearchAdvance;
